<form *ngIf="!!formGroup && !!fields" [formGroup]="formGroup">
  <div fxLayout="column" fxLayoutAlign="center stretch">
    <div>
      <fd-input [parentForm]="formGroup" [field]="fields.cpfCnpj"> </fd-input>
    </div>

    <div fxLayout="line" style="justify-content: space-between;">
      <fd-select
        (loadItemsFn)="getCnaeList($event, false)"
        [parentForm]="formGroup"
        [field]="fields.cnaeNumber"
        style="width: 51%"
      >
      </fd-select>

      <div style="width: 48%">
        <fd-input [parentForm]="formGroup" [field]="fields.mccCnae"> </fd-input>
      </div>
    </div>

    <div>
      <fd-input [parentForm]="formGroup" [field]="fields.mccAbecs"> </fd-input>
      <div *ngIf="hasAbecsMccValue()" class="mcc-abecs-warning">
        <fa-icon icon="exclamation-triangle" size="1x"></fa-icon>
        <span>Em atendimento ao Normativo 28 da ABECS, este cliente será precificado pelo MCC indicado pela ABECs.</span>
      </div>
    </div>

    <div>
      <fd-currency-input [parentForm]="formGroup" [field]="fields.billingValue">
      </fd-currency-input>
    </div>

    <fd-button
      [disabled]="this.formGroup.invalid"
      content="consultar planos"
      (trigger)="showFeeData()"
    >
    </fd-button>
  </div>
</form>
